<script lang="ts">
import {onMount} from "svelte";

interface ListItem {
	name: string;
	complete: boolean;
}

let ready: boolean = false;
let items: Array<ListItem> = [];

const loadTestItems = () => {
	items = [...items, {name: "Milk", complete: false}];
	items = [...items, {name: "Bread", complete: false}];
	items = [...items, {name: "Cheese", complete: false}];
	items = [...items, {name: "Orange", complete: false}];
	items = [...items, {name: "Apple", complete: false}];
	items = [...items, {name: "Muffin", complete: false}];
	items = [...items, {name: "Banana", complete: false}];
	items = [...items, {name: "Yoghurt", complete: false}];
	items = [...items, {name: "Pasta", complete: false}];
	items = [...items, {name: "Water", complete: false}];
	window.localStorage.setItem('items', JSON.stringify(items));
}

let newItemName: string = '';

const addItem = () => {
	if (!newItemName.length) return;
	items = [...items, {name: newItemName, complete: false}];
	window.localStorage.setItem('items', JSON.stringify(items));
	newItemName = '';
}

const removeItem = (i) => {
	items = [...items.slice(0, i), ...items.slice(i+1)];
	window.localStorage.setItem('items', JSON.stringify(items));
}

onMount(() => {
	items = JSON.parse(window.localStorage.getItem('items'));

	if ( ! (items instanceof Array)) {
		items = [];
	}

})

$: {

}

</script>

<div class="container">
	<div class="row py-2">
		<div class="col-12 display-1 text-center">
			Shopping List
		</div>
	</div>

	<div class="row py-2">
		<div class="col-9">
			<input type="text" class="form-control" bind:value={newItemName}>
		</div>
		<div class="col-3">
			<button class="btn btn-primary" type="button" on:click={addItem}>Add</button>
		</div>
	</div>

	{#each items as item, i}
		<div class="row py-2" class:bg-primary={item.complete} class:text-white={item.complete}>
			<div class="col-9 d-flex align-items-center">
				<div class="form-check">
					<input class="form-check-input" type="checkbox"
					   bind:checked={item.complete}
					   id={`input-item-${i}`}
					>
					<label class="form-check-label"
					   for={`input-item-${i}`}
					>
						{item.name}
					</label>
				</div>
			</div>
			<div class="col-3">
				<button class="btn btn-light" type="button" on:click={() => removeItem(i)}>Remove</button>
			</div>
		</div>
	{/each}
</div>
